import './BaseView.scss';

export { default } from './BaseView';
